import React from 'react';
import { 
  FileText, Receipt, FileCheck, Truck, CheckCircle,
  DollarSign, CreditCard, TrendingUp, Bell,
  BarChart3, FileBarChart, Download
} from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  FileText, Receipt, FileCheck, Truck, CheckCircle,
  DollarSign, CreditCard, TrendingUp, Bell,
  BarChart3, FileBarChart, Download
};

const Features = () => {
  const { features } = mockData;

  return (
    <section id="funcionalidades" className="py-24 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {features.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {features.subtitle}
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full mx-auto mt-6" />
        </div>

        {/* Features Grid */}
        <div className="space-y-16">
          {features.categories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="space-y-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center lg:text-left">
                {category.name}
              </h3>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.items.map((item, itemIndex) => {
                  const Icon = iconMap[item.icon];
                  return (
                    <div
                      key={itemIndex}
                      className="group bg-white p-6 rounded-xl border border-gray-200 hover:border-purple-300 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                    >
                      <div className="flex items-start space-x-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-100 to-blue-100 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                          <Icon className="w-6 h-6 text-purple-600" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-lg font-semibold text-gray-900 mb-2">
                            {item.title}
                          </h4>
                          <p className="text-sm text-gray-600 leading-relaxed">
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Additional Features Highlight */}
        <div className="mt-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl p-8 sm:p-12 text-white">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <p className="text-4xl font-bold mb-2">100%</p>
              <p className="text-purple-100">Conformidade Fiscal</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">30+</p>
              <p className="text-purple-100">Anos de Experiência</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">Ilimitado</p>
              <p className="text-purple-100">Emissões (planos pagos)</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
